import ExpertOrderIntegration from './ExpertOrderIntegration';
import TablessIntegration from './TablessIntegration';
import WinOrderIntegration from './WinOrderIntegration';
import DeliverectIntegration from './DeliverectIntegration';
import LiefersoftIntegration from './LiefersoftIntegration';
import HubriseIntegration from './HubriseIntegration';

export default {
  ExpertOrderIntegration,
  TablessIntegration,
  WinOrderIntegration,
  DeliverectIntegration,
  LiefersoftIntegration,
  HubriseIntegration,
};
